import { Button, Popconfirm, Table , Typography } from 'antd';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import { CheckCircleTwoTone, DeleteOutlined } from './Icons';
import { IMembershipCardData } from './MembershipCardModal';
import memberCardKeyService from '@/services/memberCardKeyService';
import { IMemberCardKey } from '@/types';
import Modal from 'antd/lib/modal/Modal';
import Brand from './Brand';
import { LoadBraintreeJS } from '@/components/LoadBraintreeJS';
import useBraintree from '@/hooks/useBraintree';
import { modalType } from './Modal';
const { Paragraph } = Typography;

interface ITableColumns {
  title: string;
  key?: string;
  align?: string;
  dataIndex?: string | string[];
  render: Function;
}

function mapName(n) {
  if (n == 'number') return 'Card Number'
  if (n == 'cvv') return 'Cvv'
  if (n == 'expirationDate') return 'Expiration Date'
  if (n == 'postalCode') return 'Postal Code'
  return n;
}

const BTCard = ({ ui, uiSet, reloadCards, captchaRef, configInfo }) => {
  const [errors, setErrors] = useState<string>('');
  const [confirmLoading, setConfirmLoading] = useState<boolean>(false);
  const [cvvErrors, setCvvErrors] = useState<string>('');
  const [numberErrors, setNumberErrors] = useState<string>('');
  const [postalCodeErrors, setPostalCodeErrors] = useState<string>('');
  const [expErrors, setExpErrors] = useState<string>('');

  const [cardType, setCardType] = React.useState('');

  const onCardTypeChange = ({ cards }) => {
    if (1 === cards.length) {
      const [card] = cards;

      setCardType(card.type);
    } else {
      setCardType('');
    }
  };
  const onBlur = (field, event) => { onValidityChange(event); setFocusedField('') };
  const onFocus = (field, event) => setFocusedField(event?.emittedBy ?? '');
  const onValidityChange = (e) => {
    let error = ""
    if (!e?.fields) return;
    const formValid = Object.keys(e.fields).map(function (key) {
      const valid = e.fields[key].isValid;
      const empty = e.fields[key].isEmpty;
      let err = ""
      if (!valid) {
        err += " " + mapName(key) + " is invalid. "
      }
      if (empty) {
        err += " " + mapName(key) + " is empty. "
      }
      if (key == 'number') {
        setNumberErrors(!empty ? err : '')
      }
      if (key == 'postalCode') {
        setPostalCodeErrors(!empty ? err : '')
      }
      if (key == 'expirationDate') {
        setExpErrors(!empty ? err : '')
      }
      if (key == 'cvv') {
        setCvvErrors(!empty ? err : '')
      }
      error += err
      return valid && !empty;
    }).every(x => x);
    setCardValid({ valid: formValid, message: error })
    // if(formValid) {
    //   setStripeErrors('');
    // }
  }
  const [tokenize, deviceData, clearFields] = useBraintree({ pkBraintree: configInfo.pkBraintree, onCardTypeChange, onValidityChange, onBlur, onFocus })
  const [error, setError] = React.useState(null);
  const [cardValid, setCardValid] = React.useState<{
    valid: boolean,
    message: string
  }>({ valid: false, message: "Fill the card fields" });
  const [focusedFieldName, setFocusedField] = React.useState('');
  const add_credit_card = async (e) => {
    e.preventDefault();
    setConfirmLoading(true);
    let result = null;
    if (cardValid?.valid) {
      try {
        // nmiResponse = await startPaymentRequest();
        result = await tokenize.current();
      } catch (e) {
        setConfirmLoading(false);
        return;
      }
    } else {
      setConfirmLoading(false);

      result = { error: { message: cardValid.message } };
    }
    if (result.error) {
      setConfirmLoading(false);
      setErrors(result.error.message);
    } else {

      let recaptchaToken = '';
      if (captchaRef.current) {
        try {
          recaptchaToken = await captchaRef.current.executeAsync();
        }
        catch (e) {
          Modal['error']({
            title: 'Error',
            content: 'Captcha Error',
            okText: 'Ok',

            onOk: () => {
              return false;
            },
          });
          captchaRef.current.reset();
          return;
        }
        captchaRef.current.reset();
      }

      const ret = await memberCardKeyService.AddCard({
        btToken: result?.nonce,
        deviceData: deviceData.current,
        payment_card: result?.details?.lastFour,
        payment_card_brand: result?.details?.cardType,
        payment_card_country: '',
        payment_card_zip: result?.card?.address_zip,
        exp_month: result?.details?.expirationMonth,
        exp_year: result?.details?.expirationYear,
        recaptcha_token: recaptchaToken,
      } as IMemberCardKey);
      if (ret.status === 'OK') {
        uiSet({ ...ui, showCard: false });
        clearFields.current();
        reloadCards();
      } else {
        modalType({
          type: 'error',
          title: 'Your card could not be processed.',
          content: "Please double-check your card details and try again, or use a different card. If the problem continues, contact your card issuer.",
        })
        setConfirmLoading(false);
        setErrors(ret.error);
      }
      setConfirmLoading(false);
    }
  };

  return (
    <Modal
      visible={ui.showCard}
      title="Add Credit Card"
      onOk={add_credit_card}
      closable={!confirmLoading}
      keyboard={false}
      onCancel={() => {
        if (confirmLoading) return false;
        uiSet({ ...ui, showCard: false });
      }}
      confirmLoading={confirmLoading}
    >
        <div className="flex flex-row space-x-2 md:space-x-8 mb-4">
          <div className="w-full flex flex-col space-y-2">
            <p className="text-xs md:text-sm">Card Number</p>
            <div className={`flex flex-row md:space-x-2 mb-2 md:mb-0 w-full border border-gray-300 rounded-md px-1 h-12 `}>
              {/* <HostedField
                  type="number"
                  className={`flex-1 ${'number' === focusedFieldName ? 'focused' : ''}`}
                  onBlur={onFieldBlur}
                  onFocus={onFieldFocus}
                  placeholder="Card Number"
                  ref={numberField}
                  /> */}
              <div id="card-number" className={`flex-1 bg-white ${'number' === focusedFieldName ? 'focused' : ''}`}> </div>
              <span className='self-center'>
                <Brand type={cardType} isCheckout />
              </span>
            </div>
            {numberErrors && (
              <Paragraph type="danger" className="mb-0 text-[10px] md:text-xs">
                {numberErrors}
              </Paragraph>
            )}
          </div>

          <div className="w-52 md:w-full flex flex-col space-y-2">
            {/* <HostedField
                  type="expirationDate"
                  placeholder="MM/YY"
                  onBlur={onFieldBlur}
                  onFocus={onFieldFocus}
                  className={`border border-gray-300 rounded-md px-1 h-8 ${'expirationDate' === focusedFieldName ? 'focused' : ''}`}
                /> */}
            <p className="text-xs md:text-sm">Card Expiration</p>
            <div
              id="expiration-date"
              className={`bg-white border border-gray-300 rounded-md px-1 h-12 ${'expirationDate' === focusedFieldName ? 'focused' : ''
                }`}
            ></div>

            {expErrors && (
              <Paragraph type="danger" className="mb-0 text-[10px] md:text-xs">
                {expErrors}
              </Paragraph>
            )}
          </div>
        </div>
        <div className="w-full flex flex-row space-x-2 md:space-x-8">
          <div className="w-full flex flex-col space-y-2">
            {/* <HostedField type="cvv" placeholder="CVV" ref={cvvField} className="border border-gray-300 rounded-md px-1 h-8" /> */}
            <p className="text-xs md:text-sm">CVV</p>
            <div
              id="cvv"
              className={`bg-white border border-gray-300 rounded-md px-1 h-12 ${'postalCode' === focusedFieldName ? 'focused' : ''
                }`}
            ></div>

            {cvvErrors && (
              <Paragraph type="danger" className="mb-0 text-[10px] md:text-xs">
                {cvvErrors}
              </Paragraph>
            )}
          </div>
          <div className="w-full flex flex-col space-y-2">
            {/* <HostedField type="postalCode" placeholder="ZIP / Postal Code" ref={zipField} className="border border-gray-300 rounded-md px-1 h-8" /> */}
            <p className="text-xs md:text-sm">ZIP / Postal Code</p>
            <div
              id="postal-code"
              className={`bg-white border border-gray-300 rounded-md px-1 h-12 ${'postalCode' === focusedFieldName ? 'focused' : ''
                }`}
            ></div>

            {postalCodeErrors && (
              <Paragraph type="danger" className="mb-0 text-[10px] md:text-xs">
                {postalCodeErrors}
              </Paragraph>
            )}
          </div>
        </div>
    </Modal>
  );
};

export default function MemberCardKeys({ user, configInfo, captchaRef }) {
  const [ui, uiSet] = useState<IMembershipCardData>({
    showCard: false,
  } as IMembershipCardData);
  const [keys, setKeys] = useState([] as Array<IMemberCardKey>);
  useEffect(() => {
    reloadCards();
  }, [configInfo.pkStripe]);
  const reloadCards = () => {
    memberCardKeyService.GetMemberKeyCards().then((resp) => {
      setKeys(resp);
    });
  };

  const do_delete = async (id) => {
    await memberCardKeyService.DeleteCard(id);
    reloadCards();
  };

  const columns: ITableColumns[] = [
    {
      title: 'Brand',
      align: 'left',
      dataIndex: 'payment_card_brand',
      render: (_text, record) => <Brand type={record.payment_card_brand} />,
    },
    {
      title: 'Card',
      align: 'left',
      dataIndex: 'payment_card',
      render: (_text, record) => `**** **** **** ${record.payment_card}`,
    },
    {
      title: 'Expire',
      align: 'left',
      dataIndex: ['exp_year', 'exp_month'],
      render: (_text, record: IMemberCardKey) =>
        `${record?.exp_month}/${record?.exp_year}`,
    },
    {
      title: 'Address',
      align: 'left',
      dataIndex: ['payment_card_country', 'payment_card_zip'],
      render: (text, record: IMemberCardKey) =>
        `${record?.payment_card_country}${
          record?.payment_card_zip ? ' - ' + record?.payment_card_zip : ''
        }`,
    },
    {
      title: 'Action',
      key: 'action',
      align: 'center',
      render: (text, record: IMemberCardKey) => (
        <Popconfirm
          title="Are you sure？"
          okText="Yes"
          cancelText="No"
          onConfirm={async () => await do_delete(record.member_cardkey_id)}
        >
          <a
            href="#"
            title="Delete this card"
            className="text-center mx-auto w-full"
          >
            <DeleteOutlined />
          </a>
        </Popconfirm>
      ),
    },
  ];

  return (
    <div className="border border-primary rounded-md overflow-hidden mb-8">
      {LoadBraintreeJS(configInfo.enableBraintreeGPay, configInfo.enableBraintreePaypal)}
      <div className="text-sm text-primary bg-orange-50 border-b border-primary  flex flex-row items-center w-full relative p-3">
        <span className="ml-2">Saved Credit Cards</span>
        {dayjs(user?.member_dt_next_payment) > dayjs() && (
          <CheckCircleTwoTone
            className="absolute right-4 text-2xl top-2.5"
            twoToneColor="#52c41a"
          />
        )}
      </div>
      <Table
        columns={columns as []}
        dataSource={keys}
        pagination={{ style: { padding: '0 20px' } }}
      />
      <div className="p-4">
        <Button
          type="primary"
          className="uppercase"
          onClick={() => uiSet({ ...ui, showCard: true })}
        >
          Add Card (No charges)
        </Button>
        <BTCard ui={ui} uiSet={uiSet} reloadCards={reloadCards} captchaRef={captchaRef} configInfo={configInfo}/> 
      </div>
    </div>
  );
}
